import ChildTemplate from '../_/ChildTemplate';

export default class extends ChildTemplate {
  items = [];
  open = null;
  loading = false;

  constructor(parent) {
    super(parent);
    this.emitter.on('list', data => this.set(data));
    this.emitter.on('new', data => this.setNew(data));
    this.emitter.on('read', data => this.__read(data));
    this.emitter.on('readAll', data => this.__readAll(data));
    this.emitter.on('hide', data => this.__hide(data));
  }

  get emitter() {
    return this.emitters.message;
  }

  get user() {
    return this.parent.account.user;
  }

  get count() {
    return this.items.length;
  }

  get show() {
    return !!this.items.find(i => i.Guid);
  }

  get itemsMin() {
    return this.items.filter(i => i.Guid);
  }

  init() {
    return this.get();
  }

  get() {
    return this.api
      .get('/tourclient/account/UnreadedMails')
      .then((data) => {
        this.emitter.emit('list', data.Correspondences || []);
      });
  }

  set(data) {
    if (this.items.length) {
      return;
    }
    this.items = data.map(i => ({
      ...i,
      Guid: '',
      MessagePreview: i.Text,
      time: (new Date(i.MessageDate)).getTime(),
    }));
    this.sort();
  }

  setNew(data) {
    data.ID = data.Id;
    data.MessageDate = data.DateTime;
    data.UserName = data.SenderName;
    if (!this.items.find(i => i.ID === data.ID)) {
      this.items.push({
        ...data,
        time: (new Date(data.MessageDate)).getTime(),
      });
    }
    this.sort();
  }

  sort() {
    this.items.sort((a, b) => b.time - a.time);
  }

  __read(id) {
    this.utils.array.remove(this.items, this.items.find(i => i.ID === id));
  }

  close(item) {
    this.emitter.emit('read', item.ID);
    return this.api.post('/tourclient/order/CorrespondanceShow', `id=${item.ID}&value=true`);
  }

  __hide(id) {
    const item = this.items.find(i => i.ID === id);
    if (item) {
      item.Guid = '';
    }
  }

  hide(item) {
    this.emitter.emit('hide', item.ID);
  }

  send(item, message) {
    this.loading = true;
    return this.api
      .post('/tourclient/order/SendMessage',
        `Code=${
          item.AgreementCode
        }&Message=${
          message
        }&CorrespondenceTypeId=${
          item.CorrespondenceTypeId
        }&ToMessageId=0&ToSupplier=false`)
      .then((data) => {
        this.open = null;
        this.close(item);
        this.emitter.emit('send', {
          ...data,
          Code: item.AgreementCode,
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  __readAll() {
    this.items = [];
  }

  readAll() {
    this.emitter.emit('readAll');
    return this.api.post('/tourclient/account/SetReadedAllMessages', '');
  }
}
